import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWaterDrop = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 10,
		strokeWidth: 1.5,
		d: "M9.75 15C8 15 6.5 13.5 6.5 11.75m9.25-.323c0 3.357-2.571 6.073-5.75 6.073s-5.75-2.724-5.75-6.073c0-3.35 3-4.677 5.75-8.677 2.75 4 5.75 5.319 5.75 8.677Z"
	})]
});
const ForwardRef = forwardRef(SvgWaterDrop);
export { ForwardRef as ReactComponent };
